// extracted by mini-css-extract-plugin
export default {"form":"Form_form__e1yzW","title":"Form_title__5gZHF","form-control":"Form_form-control__6XwPo"};